
import React, {Component} from 'react';
import {Row,Col,Modal,Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import DatePicker from './DatePicker'
import moment from 'moment'

class PeriodSelectDateModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {start_date:'',end_date:''}
  }

  componentWillReceiveProps(newProps){
    //console.log('newProps',newProps.rangeValue)
    if(newProps.rangeValue!==undefined){
      let startDateM = moment(newProps.rangeValue.startDate, 'YYYY/MM/DD')
      let start_date = startDateM.format('DD/MM')+'/'+(startDateM.format('YYYY')*1 + 543);

      let endDateM = moment(newProps.rangeValue.endDate, 'YYYY/MM/DD')
      let end_date = endDateM.format('DD/MM')+'/'+(endDateM.format('YYYY')*1 + 543);

      this.setState({start_date:start_date,end_date:end_date})
    }
  }

  onHide(){
    if(this.props.onClose!==undefined)
      this.props.onClose()
  }

  onDateChange(key,value){
    let state = this.state
    state[key] = value
    this.setState(state)
  }

  onOKClick(){
    if(this.props.onSelect!==undefined){
      this.props.onSelect(this.state)      
    }
  }


  render(){
    let {start_date,end_date} = this.state
    return (
      <Modal show={this.props.show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="smallwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{this.props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6}>
                เริมต้น
                <DatePicker                
                      value={start_date}
                      onChange={this.onDateChange.bind(this,'start_date')}
                      showIcon={true}
                      showFooter={true}
                      buddhistEra={true}
                      style={{ display: 'inline-block', minWidth: '160px' }}
                      maxWidth='100%'
                    />
                </Col>
                <Col md={6}>
                สิ้นสุด
                <DatePicker              
                      value={end_date}
                      onChange={this.onDateChange.bind(this,'end_date')}
                      showIcon={true}
                      showFooter={true}
                      buddhistEra={true}
                      style={{ display: 'inline-block', minWidth: '160px' }}
                      maxWidth='100%'
                    />
                </Col>
             </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='primary' onClick={this.onOKClick.bind(this)}><FontAwesome name='save'/>&nbsp;บันทึก</Button>
            <Button onClick={this.onHide.bind(this)}><FontAwesome name='close'/>&nbsp;ยกเลิก</Button>
          </Modal.Footer>
       </Modal>
    )
  }
}


export default PeriodSelectDateModal;





// WEBPACK FOOTER //
// ./src/component/element/PeriodSelectDateModal.js